import { Section, containerSizes } from './Section';
import register from './register';

register(Section, {
	sizes: containerSizes,
	defaultSize: 'md',
});
